import React, { useEffect, useState } from 'react';
import { makeStyles, Container, Box, Button, Chip } from '@material-ui/core';
import Page from 'src/components/Page';
import CustomDataTable from 'src/components/Table/CustomDataTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteRouteCategoryAction,
  getRouteCategoryAction,
  toggleRouteCategoryAction
} from 'src/store/actions/RouteCategoryActions';
import CustomModal from 'src/components/CustomModal';
import RouteCategoryManager from './components/RouteCategoryManager';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));

function RoutesCategory() {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const routeCategories = useSelector(
    (state) => state.RouteCategories.routeCategories
  );

  const [loading, setLoading] = useState(false);
  const [modalControl, setModalControl] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    async function fetchRouteCategories() {
      setLoading(true);
      await dispatch(getRouteCategoryAction('', profile));
      setLoading(false);
    }

    fetchRouteCategories();
  }, []);

  const handleToggleStatus = async (row) => {
    const { id, accessStatus } = row;
    const status = accessStatus == 1 ? 0 : 1;
    const toggle = window.confirm(
      'Are you sure you want to toggle this route category status?'
    );
    if (toggle) {
      const response = await dispatch(
        toggleRouteCategoryAction(id, { accessStatus: status }, profile)
      );
    }
  };

  const handleDelete = async (id) => {
    const reset = window.confirm(
      'Are you sure you want to delete this Route Category?'
    );
    if (reset) {
      const response = await dispatch(deleteRouteCategoryAction(id, profile));
    }
  };

  const tableConfig = [
    {
      title: 'SN',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Name',
      value: 'name',
      align: 'center'
    },

    {
      title: 'Status',
      value: 'status',
      align: 'center',
      render: (item) => {
        if (item.accessStatus == 0) {
          return (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              label="Deactivated"
            />
          );
        }
        return (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        );
      }
    },
    {
      title: 'Date Created',
      value: 'dateCreated',
      align: 'center',
      render: (row) => moment(row.transDate).format('DD-MM-YYYY')
    },
    profile?.super == 1 && {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (item) => (
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            id="route-mngr"
            variant="contained"
            color="primary"
            size="small"
            onClick={(e) => handleModal(e, item)}
          >
            Update Route
          </Button>
          &nbsp;
          <Button
            onClick={() => handleToggleStatus(item)}
            variant="contained"
            color="primary"
            size="small"
          >
            {item.accessStatus == 0 ? 'Activate ' : 'Deactivate '}
          </Button>
          &nbsp;
          <Button
            onClick={() => handleDelete(item.id)}
            variant="contained"
            color="primary"
            size="small"
          >
            Delete
          </Button>
        </Box>
      )
    }
  ];

  const handleModal = (e, payload) => {
    const currModalID = e.currentTarget.id;
    if (currModalID) setModalControl(currModalID);
    if (payload) setModalData(payload);
  };

  const closeModal = () => setModalControl(false);

  const tableActions = () => (
    <Button
      id="route-mngr"
      variant="contained"
      color="primary"
      onClick={handleModal}
    >
      Create Route Category
    </Button>
  );

  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        <Box>
          <CustomDataTable
            className={classes}
            tableConfig={tableConfig}
            tableData={routeCategories}
            tableActions={profile?.super == 1 ? tableActions : null}
            loading={loading}
            filterField="name"
          />
        </Box>
      </Container>

      <CustomModal
        open={modalControl === 'route-mngr'}
        handleClose={closeModal}
        title="Manage Route Category"
      >
        <RouteCategoryManager handleClose={closeModal} modalData={modalData} />
      </CustomModal>
    </Page>
  );
}

export default RoutesCategory;
